import React from "react";

import { ResponsiveAccordion } from "./ResponsiveAccordion";
import { useFooterClickEventTracker } from "./useFooterClickEventTracker";

export const PrivacyAndTerms = () => {
  const { createPublishFooterClickEventFunction } =
    useFooterClickEventTracker();

  return (
    <ResponsiveAccordion
      label="Privacy &amp; Terms"
      ariaControlsName="nav__additional_info"
      defaultExpanded={false}
    >
      <ul className="text-sm text-green font-bold" id="nav__additional_info">
        <li className="py-sm mr-md">
          <a
            href={`/info/terms-of-use`}
            onClick={createPublishFooterClickEventFunction("terms of use")}
          >
            Terms of use
          </a>
        </li>
        <li className="py-sm mr-md">
          <a
            href={`/info/commercial-terms-of-use`}
            onClick={createPublishFooterClickEventFunction(
              "commercial terms of use"
            )}
          >
            Commercial terms of use
          </a>
        </li>
        <li className="py-sm mr-md">
          <a
            href={`/info/privacy-policy`}
            onClick={createPublishFooterClickEventFunction("privacy policy")}
          >
            Privacy policy
          </a>
        </li>
        <li className="py-sm mr-md">
          <a
            href={`/info/privacy-policy#ccpa-do-not-sell`}
            onClick={createPublishFooterClickEventFunction(
              "do not sell my personal information"
            )}
          >
            Do not sell my personal information
          </a>
        </li>
      </ul>
    </ResponsiveAccordion>
  );
};
